"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_query_1 = require("@tanstack/react-query");
const bookingSlice_1 = require("../store/slices/bookingSlice");
const store_1 = require("../store/store");
const useComingAppointments = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const bookedAppointments = (0, store_1.useAppSelector)((state) => state.booking.bookedAppointments);
    const fetchFunc = () => axios.get('/api/booking/get-coming-appointments').then((response) => {
        const appointments = response.data.data;
        appointments.sort((a, b) => {
            if (a.fromDate < b.fromDate)
                return -1;
            if (a.fromDate > b.fromDate)
                return 1;
            return 0;
        });
        if (!_.isEqual(bookedAppointments, appointments)) {
            dispatch((0, bookingSlice_1.setBookedAppointments)(appointments));
        }
        return response.data.data;
    });
    return (0, react_query_1.useQuery)({ queryKey: ['get-coming-appointments'], queryFn: fetchFunc });
};
exports.default = useComingAppointments;
